import { httpService, WebRequestFactory, fromPascalToCamel, fromStatusCodeToGenericError } from "@pjs/http";
import { apiConfig } from "../../../ApiConfig";
import { ITemporaryAccessDetails } from "../interfaces/ITemporaryAccessDetails";
import { BackendTemporaryAccessDetailsResponse } from "../types/BackendTemporaryAccessDetailsResponse";

export const getTemporaryAccessDetails = WebRequestFactory.createGet<ITemporaryAccessDetails | null>({
    errorMapper: fromStatusCodeToGenericError,
    http: httpService,
    responseMapper: (response: Response) => {
        if (response.status !== 200) {
            return Promise.resolve(null);
        }

        return fromPascalToCamel<BackendTemporaryAccessDetailsResponse, ITemporaryAccessDetails>(response);
    },
    url: () => apiConfig.grantedTemporaryAccessDetails()
});
